import React, { useState, useCallback, type ReactNode } from 'react';
import Link from '@atlaskit/link';
import Banner from '@atlaskit/banner';
import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const ContactYourAdminLink = ({ children }: { children: ReactNode }) =>
	fg('replace-anchor-with-link__jira-werewolves') ? (
		<Link href="/jira/contact-administrator">{children}</Link>
	) : (
		// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
		<a href="/jira/contact-administrator">{children}</a>
	);

export const ContactAdminBanner = () => {
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState<boolean>(true);

	const handleDismissClick = useCallback(() => {
		setIsOpen(false);
	}, [setIsOpen]);

	if (!isOpen) {
		return null;
	}

	return (
		<Box xcss={bannerContainerStyles}>
			<Banner
				testId="business-form.ui.form-submission.contact-admin-banner.banner"
				appearance="announcement"
			>
				<FormattedI18nMessage
					componentsMapping={{
						link: ContactYourAdminLink,
					}}
					message={formatMessage(messages.needToEdit, {
						linkStart: '{linkStart}',
						linkEnd: '{linkEnd}',
					})}
				/>
			</Banner>
			<Box xcss={buttonContainerStyles}>
				<Button
					label="dismiss"
					appearance="subtle"
					iconBefore={
						<CrossIcon
							LEGACY_size="medium"
							spacing="spacious"
							label={formatMessage(messages.dismiss)}
							color={token('color.text.inverse')}
						/>
					}
					onClick={handleDismissClick}
				/>
			</Box>
		</Box>
	);
};

const bannerContainerStyles = xcss({
	position: 'relative',
});

const buttonContainerStyles = xcss({
	position: 'absolute',
	top: 'space.100',
	right: 'space.100',
});
